<template>
    <span
        class="tooltip"
        :class="this.positionClass"
        :data-tooltip="time.full"
    >
        {{time.display}}
    </span>
</template>

<script>
import moment from 'moment'

export default {
    name : 'Timestamp',
    props : {
        value : [Number, String],
        isFull : {
            type : Boolean,
            default : false,
        },
        noTime : {
            type : Boolean,
            default : false,
        },
        position : {
            type : String,
            default : 'right',
        },
        or : {
            type : String,
            default : 'Unknown',
        },
        displayInUtc : {
            type : Boolean,
            default : false,
        },
        dateFormat : {
            type : String,
            default : 'M/D/YY'
        },
        timeFormat : {
            type : String,
            default : 'h:mm:ss A',
        },
        fullFormatOverride : {
            type : String,
            default : null,
        },
    },
    computed : {
        time () {

            if(!this.value){
                return {
                    full : this.or,
                    display : this.or,
                };
            }

            let date = moment.utc(this.value);
            if(!this.displayInUtc){
                date = date.local();
            }
            let full = date.format(`${this.dateFormat} ${this.timeFormat}`),
                parts = full.split(' '),
                part;

            if(this.noTime){
                return {
                    full : parts[0],
                    display : parts[0],
                }
            }

            let one_day = 1000 * 60 * 60 * 24;
            let now = new Date().getTime();

            if(!this.fullFormatOverride && this.value < now + one_day && this.value > now - one_day){
                part = date.format(this.timeFormat);
            } else {
                part = parts[0];
            }//el

            return {
                full : full,
                display : this.isFull ? full : part,
            };

        },
        positionClass () {
            return 'is-tooltip-' + this.position;
        }
    }
}
</script>
